import {
  AfterViewInit,
  ApplicationRef,
  Component,
  ComponentFactoryResolver,
  Injector,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { BasePortalOutlet, DomPortalOutlet, TemplatePortal } from '@angular/cdk/portal';

@Component({
  selector: 'app-modal-container',
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss']
})
export class ModalContainerComponent implements OnInit, AfterViewInit {
  private portalHost: BasePortalOutlet;
  @ViewChild('content', { read: TemplateRef }) modalContent: TemplateRef<any>;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef,
    private viewContainerRef: ViewContainerRef,
  ) { }

  ngOnInit(): void {
    this.portalHost = new DomPortalOutlet(
      document.querySelector('body'),
      this.componentFactoryResolver,
      this.appRef,
      this.injector
    );
  }

  ngAfterViewInit() {
    const templatePortal = new TemplatePortal(this.modalContent, this.viewContainerRef);
    this.portalHost.attach(templatePortal);
  }
}
